import React, { useState } from "react";
import SystemPropertyField from "./SystemPropertiesFormField";


const AddSystemPropertyForm = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "System Properties", url: "/system-properties" },
        { content: "Add System Property", url: "" }
    ])
    return (
        <>
            <SystemPropertyField crumbs={crumbs} title={"Add System Property"} btnText={"Create"} />

        </>
    )
}
export default AddSystemPropertyForm;